export const MAIN_PANEL_RESERVED_WIDTH = 256;
export const MAIN_PANEL_HEADER_RESERVED_HEIGHT = 56;
export const MAIN_PANEL_DRAG_BUFFER = 18;

export const DEFAULT_PANEL_SPAWN_POSITION = {
  x: MAIN_PANEL_RESERVED_WIDTH + MAIN_PANEL_DRAG_BUFFER,
  y: 20,
};

export const DEFAULT_PANEL_INITIAL_SIZE = {
  width: 380,
  height: 560,
};

export const PANEL_SPAWN_OFFSET = {
  x: 6,
  y: 40,
};

export const PANEL_SPAWN_MAX_STEPS = 8;

let panelSpawnCounter = 0;

export const getDefaultPanelSpawnPosition = () => ({
  ...DEFAULT_PANEL_SPAWN_POSITION,
});

export const getDefaultPanelInitialSize = () => ({
  ...DEFAULT_PANEL_INITIAL_SIZE,
});

export const getNextPanelSpawnPosition = () => {
  const step = panelSpawnCounter % PANEL_SPAWN_MAX_STEPS;
  panelSpawnCounter += 1;
  return {
    x: DEFAULT_PANEL_SPAWN_POSITION.x + PANEL_SPAWN_OFFSET.x * step,
    y: DEFAULT_PANEL_SPAWN_POSITION.y + PANEL_SPAWN_OFFSET.y * step,
  };
};
